var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6667 0C23.1467 0 0 23.1467 0 51.6667C0 80.1867 23.1467 103.333 51.6667 103.333C80.1867 103.333 103.333 80.1867 103.333 51.6667C103.333 23.1467 80.1867 0 51.6667 0ZM37.665 73.8317L19.1167 55.2833C17.1017 53.2683 17.1017 50.0133 19.1167 47.9983C21.1317 45.9833 24.3867 45.9833 26.4017 47.9983L41.3333 62.8783L76.88 27.3317C78.895 25.3167 82.15 25.3167 84.165 27.3317C86.18 29.3467 86.18 32.6017 84.165 34.6167L44.95 73.8317C42.9867 75.8467 39.68 75.8467 37.665 73.8317Z",
    fill: "#329D9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.fb559d5ab7cde075a870be2fc57144d2.svg";
export { ForwardRef as ReactComponent };